import React from 'react';
import { FORM_FIELDS_MAP } from 'features/new-candidate/constants';
import { useGlobalStyles } from 'GlobalStyles';
import strings from 'strings';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';

export const RecruiterSection = ({ onSelect, recruiter }) => {
  const globalClasses = useGlobalStyles();

  return (
    <FPCard className={globalClasses.newItemsSection}>
      <FPCardContent
        headerProps={{
          title: strings.candidates.creation.assignRecruiter.title,
          subheader: strings.candidates.creation.assignRecruiter.subtitle,
          variant: 'section'
        }}
        variant="relaxed"
      >
        <div className="inputContainer">
          <AutocompleteSelect
            displayKey="full_name"
            name={FORM_FIELDS_MAP.Recruiter.key}
            onSelect={onSelect}
            placeholder={strings.candidates.creation.assignRecruiter.placeholder}
            selectedValue={recruiter}
            url={`${Endpoints.Recruiters}/myTeam`}
          />
        </div>
      </FPCardContent>
    </FPCard>
  );
};
